export const API =
  "https://l5jehgtl26.execute-api.ap-southeast-1.amazonaws.com/production/api/v1";
// export const API = "http://localhost:5000/api/v1";
